import {
  useFxWorkspaceContext,
  type FxBreaklineType,
} from '@mobile-mapping/providers';
import { t } from '@trimble/i18n';
import { Component, JSX } from 'solid-js';

export interface FxBreaklineTypeRowActionsProps {
  readonly workspaceId: string;
  readonly breaklineType: FxBreaklineType;
}

export const FxBreaklineTypeRowActions: Component<
  FxBreaklineTypeRowActionsProps
> = (props): JSX.Element => {
  const fxWorkspace = useFxWorkspaceContext();

  const stopTreeRowInteraction = (event: Event): void => {
    event.stopPropagation();
  };

  const handlePublish = (event: MouseEvent): void => {
    stopTreeRowInteraction(event);
    fxWorkspace.publishBreakline(props.workspaceId, props.breaklineType);
  };

  return (
    <div class="flex items-center gap-1 pr-2">
      <button
        type="button"
        class="inline-flex h-8 w-8 items-center justify-center rounded hover:bg-background-secondary"
        aria-label={t('mobileMapping.fxWorkspace.breaklines.publish')}
        title={t('mobileMapping.fxWorkspace.breaklines.publish')}
        data-testid={`fx-breakline-publish-${props.workspaceId}-${props.breaklineType}`}
        onClick={handlePublish}
        onPointerDown={stopTreeRowInteraction}
      >
        <i class="icon-font tc-icon-launch i16" aria-hidden="true" />
      </button>
    </div>
  );
};
